import { combineReducers } from 'redux/es/redux.mjs';

import feVerified from '~/common/components/UnderwriterCheckbox/redux/reducers';
import { loanSummaryUpsertOrDelete, url } from '~/common/redux/reducers';

import { HomeReducer as home } from '../pages/Home/redux';

// Keep this organized for convenience in Redux Devtools
const rootReducer = combineReducers({
  feVerified,
  url,
  home,
  loanSummaryUpsertOrDelete,
});

export default rootReducer;
